import { createStore } from "zustand/vanilla";
import { initialState } from "./ListadoReducer";

export const defaultListadoState = {
  ...initialState,
  pantalla: undefined,
  loading: false,
  sideData: {},
  carrusel: false,
  display_container: undefined,
  subirDatosSeleccionados: undefined,
  paginaActual: 0,
  registrosPorPagina: 0,
  registrosTotales: 0,
};

export const createListadoState = (set, get) => ({
  ...defaultListadoState,

  getPantalla: () => get().pantalla,
  setPantalla: (pantalla) => set({ pantalla }),

  getDatos: () => get().datos,
  setDatos: (datos = []) => set({ datos }),

  getCabeceras: () => get().cabeceras,
  setCabeceras: (cabeceras = []) => set({ cabeceras }),

  getFiltros: () => get().filtros,
  setFiltros: (filtros = []) => set({ filtros }),

  getFiltroActivo: () => get().filtroActivo,
  setFiltroActivo: (filtroActivo = {}) => set({ filtroActivo }),

  getFiltrosAAplicar: () => get().filtrosAAplicar,
  setFiltrosAAplicar: (filtrosAAplicar = {}) => set({ filtrosAAplicar }),

  getLoadingPantalla: () => get().loading_pantalla,
  setLoadingPantalla: (loading_pantalla) => set({ loading_pantalla }),

  getLoading: () => get().loading,
  setLoading: (loading) => set({ loading }),

  getFiltrosUsuarioAlCargarPagina: () => get().filtrosUsuarioAlCargarPagina,
  setFiltrosUsuarioAlCargarPagina: (filtrosUsuarioAlCargarPagina = {}) =>
    set({ filtrosUsuarioAlCargarPagina }),

  getOpcionesListado: () => get().opcionesListado,
  setOpcionesListado: (opcionesListado = {}) => set({ opcionesListado }),

  getOpcionesPantalla: () => get().opcionesPantalla,
  setOpcionesPantalla: (opcionesPantalla) => set({ opcionesPantalla }),

  getListadoBotones: () => get().listadoBotones,
  setListadoBotones: (listadoBotones = []) => set({ listadoBotones }),

  getDatosSeleccionados: () => get().datos_seleccionados,
  setDatosSeleccionados: (datos_seleccionados = []) =>
    set({ datos_seleccionados }),

  getIdGlobal: () => get().id_global,
  setIdGlobal: (id_global) => set({ id_global }),

  getPaginaActual: () => get().paginaActual,
  setPaginaActual: (paginaActual = 0) => set({ paginaActual }),

  getRegistrosPorPagina: () => get().registrosPorPagina,
  setRegistrosPorPagina: (registrosPorPagina = 0) =>
    set({ registrosPorPagina }),

  getRegistrosTotales: () => get().registrosTotales,
  setRegistrosTotales: (registrosTotales = 0) => set({ registrosTotales }),

  getSideData: () => get().sideData,
  setSideData: (sideData = {}) => set({ sideData }),

  getCarrusel: () => get().carrusel,
  setCarrusel: (carrusel) => set({ carrusel }),

  getDisplayContainer: () => get().display_container,
  setDisplayContainer: (display_container) => set({ display_container }),

  getCeldas: () => get().celdas,
  setCeldas: (celdas = {}) => set({ celdas }),

  setDatoEspecifico: ({ indiceData, key, value }) =>
    set((state) => {
      const datos = [...state.datos];

      if (!datos[indiceData]) {
        return state;
      }

      datos[indiceData] = {
        ...datos[indiceData],
        [key]: value,
      };

      return { datos };
    }),

  refrescarCelda: (id) =>
    set((state) => ({
      celdas: {
        ...state.celdas,
        [id]: (state.celdas[id] || 0) + 1,
      },
    })),

  setCeldaRef: (id) =>
    set((state) => ({
      celdas: {
        ...state.celdas,
        [id]: 1,
      },
    })),

  resetListadoState: () => set({ ...defaultListadoState }),
});

export const createListadoStateStore = (initialValues = {}) =>
  createStore((set, get) => ({
    ...createListadoState(set, get),
    ...initialValues,
  }));
